// Constancias de eliminación de credenciales (AB#762/763).
// El PDF se baja con fetch + blob porque el endpoint pide Authorization, que un <a href> no manda.

const API_BASE = process.env.REACT_APP_API_URL || 'https://localhost:5001/api/v1';

export const CREDENCIAL_LABEL = {
  Ciec: 'CIEC',
  EFirma: 'e.firma',
};

export const RESGUARDO_LABEL = {
  SatGoManaged: 'Resguardo de SatGo',
  Byok: 'Vault propio (BYOK)',
};

// Describe el resultado igual que el PDF: eliminada y purgada, borrado lógico, o deshabilitada (BYOK).
export const describirResultado = (c) => {
  if (c.accionSolicitada === 'Deshabilitar') return 'Deshabilitada';
  if (c.purgada === true) return 'Eliminada y purgada';
  if (c.purgada === false) return 'Borrado lógico';
  return 'Eliminada';
};

export async function descargarConstanciaEliminacion(folio, getAuthHeaders) {
  const headers = await getAuthHeaders();
  const response = await fetch(`${API_BASE}/constancias-eliminacion/${encodeURIComponent(folio)}`, { headers });
  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw new Error(body?.message || `No se pudo descargar la constancia (error ${response.status}).`);
  }
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `constancia-eliminacion-${folio}.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export async function listarConstanciasEliminacion({ rfc, page, pageSize }, getAuthHeaders) {
  const headers = await getAuthHeaders();
  const params = new URLSearchParams({ page, pageSize });
  if (rfc) params.set('rfc', rfc);
  const response = await fetch(`${API_BASE}/constancias-eliminacion?${params}`, { headers });
  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw new Error(body?.message || `Error ${response.status}`);
  }
  return response.json();
}
